import type { OrderProductOptions } from "../OrderProductOptions.js";
import { ProductOption, productOptionKeyMap } from "../ProductOption.js";
import { calculatePriceForProductOption } from "./calculatePriceForProductOption.js";

export function getPricesForOptions(
	basePrice: number,
	options: Omit<OrderProductOptions, "size"> | undefined,
): Record<ProductOption, number> {
	return Object.fromEntries(
		Object.values(ProductOption).map((option) => [
			option,
			options ? calculatePriceForProductOption(basePrice, option, options[productOptionKeyMap[option]]) : 0,
		]),
	) as Record<ProductOption, number>;
}
